import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface DiscardChangesDialogData {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
}

@Component({
  selector: 'app-discard-changes-dialog',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './discard-changes-dialog.component.html',
  styleUrl: './discard-changes-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscardChangesDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef<boolean>);
  private readonly dialogConfig = inject(DynamicDialogConfig<DiscardChangesDialogData>);

  private readonly data = computed<DiscardChangesDialogData>(() => ({
    title: this.dialogConfig.data?.title ?? 'Porzucić zmiany?',
    message: this.dialogConfig.data?.message ?? '',
    confirmLabel: this.dialogConfig.data?.confirmLabel ?? 'Odrzuć zmiany',
    cancelLabel: this.dialogConfig.data?.cancelLabel ?? 'Wróć do edycji',
  }));

  readonly title = computed(() => this.data().title);
  readonly message = computed(() => this.data().message);
  readonly confirmLabel = computed(() => this.data().confirmLabel);
  readonly cancelLabel = computed(() => this.data().cancelLabel);
  readonly titleId = computed(() => this.dialogConfig.ariaLabelledBy ?? 'discard-changes-dialog-title');
  readonly usesDynamicDialogHeader = computed(() =>
    Boolean(this.dialogConfig.header) && this.dialogConfig.showHeader !== false
  );

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
